export const limitFields = [
  ['recordingMinutesOverride', 'Recording minutes / month'],
  ['transcriptionMinutesOverride', 'Transcribed minutes / month'],
  ['storageGbOverride', 'Storage GB'],
  ['visitorMinutesOverride', 'Visitor minutes / month'],
  ['widgetReportsOverride', 'Widget reports / month'],
] as const;

export type OverrideField = 'plan' | 'ticketQuotaOverride' | 'featureAccess' | typeof limitFields[number][0];
export interface OverrideAttribution {
  value: unknown;
  reason: string | null;
  actorId: string;
  actorName: string | null;
  occurredAt: string;
}

export function matchingAttribution(
  company: { overrideAttribution?: Partial<Record<OverrideField, OverrideAttribution>> },
  field: OverrideField,
  value: unknown,
) {
  const entry = company.overrideAttribution?.[field];
  return entry?.value === value ? entry : undefined;
}

const labels: Record<string, string> = {
  plan: 'Plan', ticketCap: 'Monthly ticket cap', access: 'Recording and pins',
  ...Object.fromEntries(limitFields),
};

export function describeOverrideEvent(action: string, metadata: Record<string, unknown> | null): string {
  // Match the existing admin/adminLimits audit writers and the per-field
  // reader in api/src/adminOverrideContext.ts; no new event format is stored.
  if (!metadata) return 'Details unavailable';
  const values = action === 'admin.recording_limits_set'
    ? metadata.next : action === 'admin.plan_override_set' ? { plan: metadata.plan }
    : action === 'admin.quota_override_set' ? { ticketCap: metadata.ticketCap }
    : action === 'admin.feature_access_set' ? { access: metadata.access } : null;
  if (!values || typeof values !== 'object' || Array.isArray(values)) return 'Administrative change recorded';
  return Object.entries(values).filter(([key]) => Object.hasOwn(labels, key)).map(([key, value]) => {
    const shown = value === null ? 'follows plan' : typeof value === 'number' ? value.toLocaleString()
      : typeof value === 'string' ? value : 'unavailable';
    return `${labels[key]}: ${shown}`;
  }).join('; ') || 'Details unavailable';
}
